<template>
  <span class="help-icon">
    <Icon :id="helpId" name="question-circle" title />
    <BPopover :target="helpId" triggers="hover focus">
      <div v-html="help"></div>
    </BPopover>
  </span>
</template>

<script>
import Icon from "./BaseIcon";

export default {
  name: "BaseControlHelp",
  components: {
    Icon
  },
  props: {
    id: {
      type: String,
      required: true
    },
    help: {
      type: String,
      default: ""
    }
  },
  computed: {
    hasHelp() {
      return this.help.length > 0;
    },
    helpId() {
      return `${this.id}_help`;
    }
  }
};
</script>

<style lang="scss">
.help-icon {
  cursor: pointer;
  margin-left: 5px;
}
</style>
